import { render, staticRenderFns } from "./formListaEmbarque.vue?vue&type=template&id=471157df&scoped=true&"
import script from "./formListaEmbarque.vue?vue&type=script&lang=js&"
export * from "./formListaEmbarque.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471157df",
  null
  
)

export default component.exports